export default __webpack_public_path__ + "assets/media/sad.d800e6be.png";